import React from 'react';
import InputWrapper from './InputWrapper';
import { getListeChoix } from './utils';

const DropDownListInput = ({ field, fieldId, value, onChange, label, isRequired, error, language }) => {
  const dropdownOptions = getListeChoix(field);
  
  if (!dropdownOptions || dropdownOptions.length === 0) {
    return null;
  }
  
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <select
        className="profile-input form-input"
        value={value || ''}
        onChange={e => onChange(fieldId, e.target.value || null)}
        disabled={field.readOnly || false}
      >
        <option value="">-- {language === 'fr' ? 'Sélectionner' : 'Select'} --</option>
        {dropdownOptions.map((option, index) => {
          const optionValue = option.value !== undefined ? option.value : option;
          const optionLabel = option.label !== undefined ? option.label : option;
          return (
            <option key={index} value={optionValue}>
              {optionLabel}
            </option>
          );
        })}
      </select>
    </InputWrapper>
  );
};

export default DropDownListInput;

